export default __webpack_public_path__ + "files/btn_arrow_r_hover.png";